<template>
  <div class="container">
    <content-header :data="[{text: '抽奖活动一览', path: '/lottery/list'},{text:(curObj.id ? '修改':'添加')+'抽奖活动', path: ''}]"></content-header>
    <div class="content">
      <el-form :model="curObj" :rules="curObjRules" ref="curObjForm" label-position="right" label-width="0px">
        <el-form-item prop="name" label="抽奖活动名称" :label-width="formLabelWidth">
          <el-input name="name" v-model="curObj.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="活动时间" :label-width="formLabelWidth" required>
          <el-col :span="6">
            <el-form-item prop="startTime">
              <el-date-picker type="date" placeholder="开始日期" v-model="curObj.startTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="1"><span>至</span></el-col>
          <el-col :span="6">
            <el-form-item prop="endTime">
              <el-date-picker placeholder="结束日期" v-model="curObj.endTime" value-format="yyyy-MM-dd" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-form-item>

        <el-form-item prop="image" label="抽奖活动图片" :label-width="formLabelWidth">
          <el-upload
            class="avatar-uploader"
            action="//upload-z2.qiniup.com"
            :data="uploadForm"
            :show-file-list="false"
            :on-success="uploadPhotoSuccess"
            :before-upload="beforePhotoUpload"
            :on-error="uploadError">
            <img v-if="curObj.image" :src="domainPic + curObj.image" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item prop="lotteryDescription" label="抽奖活动说明" :label-width="formLabelWidth">
          <ky-editor v-model="curObj.lotteryDescription"
            ref="myQuillEditor">
          </ky-editor>
        </el-form-item>
        <el-form-item prop="prizeDescription" label="奖品说明" :label-width="formLabelWidth">
          <ky-editor v-model="curObj.prizeDescription"
            ref="myQuillEditor">
          </ky-editor>
        </el-form-item>
        <el-form-item prop="advertising" label="广告文字" :label-width="formLabelWidth">
          <ky-editor v-model="curObj.advertising"
            ref="myQuillEditor">
          </ky-editor>
        </el-form-item>
        <el-form-item :label-width="formLabelWidth">
          <el-button @click="isObjShow = false">取 消</el-button>
          <el-button type="primary" @click="confirmHandle">确 定</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import date from 'utils/date'
  import LotteryModel from 'models/lottery'
  import CommonModel from 'models/common'
  import KyEditor from 'components/KyEditor'

  export default {
    components: {
      KyEditor,
    },
    data () {
      var validateEndTime = (rule, value, callback) => {
        if (value === '') {
          // callback(new Error('请再次输入密码'));
        } else if (value <= this.curObj.startTime) {
          callback(new Error('结束日期必须晚于开始日期!'))
        } else {
          callback()
        }
      }
      return {
        domainPic: constants.basic.domain_pic,
        isObjShow: false,
        categoryIds: [],
        curObj: {
          id: '',
          name: '',
          startTime: '',
          endTime: '',
          image: '',
          lotteryDescription: '',
          prizeDescription: '',
          advertising: ''
        },
        formLabelWidth: '120px',
        curObjRules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          startTime: [{ required: true, message: '请输入开始日期', trigger: 'blur' }],
          endTime: [{ required: true, message: '请输入结束日期', trigger: 'blur' },
            { validator: validateEndTime, trigger: 'blur' }],
          image: [{ required: true, message: '请上传图片', trigger: 'blur' }],
          lotteryDescription: [{ required: true, message: '请输入抽奖活动说明', trigger: 'blur' }],
          prizeDescription: [{ required: true, message: '请输入奖品说明', trigger: 'blur' }],
          advertising: [{ required: true, message: '请输入广告文字', trigger: 'blur' }],
        },
        //
        uploadForm: {key: '', token: ''},
        qiniuHost: '',
        datePickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      }
    },
    created () {
      //
      this.curObj.id = this.$route.query.id
      console.log(this.curObj.id)
      if (this.curObj.id) {
        LotteryModel.get({
          id: this.curObj.id
        }).then(res => {
          this.curObj = res
          this.curObj.startTime = this.curObj.startTime.substr(0, 10)
          this.curObj.endTime = this.curObj.endTime.substr(0, 10)
          console.log(this.curObj)
        })
      }
    },
    methods: {
      uploadRemove (file, fileList) {
        console.log(file)
      },
      uploadError (err, file, fileList) {
        console.log(err)
      },
      uploadExceed (files, fileList) {
        console.log(files.length)
      },
      uploadPhotoSuccess (response, file, fileList) {
        // console.log(response)
        this.curObj.image = response.key
      },
      beforePhotoUpload (file) {
        const isPic = (file.type === 'image/jpeg' || file.type === 'image/png')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isPic) {
          this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
          return false
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!')
          return false
        }
        //
        if (!this.uploadForm.token) {
          return CommonModel.getQiniuUptoken().then(res => {
            this.qiniuHost = res.qiniuHost
            this.uploadForm.token = res.uptoken
            let curr = date(new Date().getTime(), 'yyyyMMdd')
            let prefix = 'lottery'
            let suffix = file.name
            this.uploadForm.key = encodeURI(`${prefix}/${curr}_${suffix}`)
            console.log(this.uploadForm)
          })
        } else {
          let curr = date(new Date().getTime(), 'yyyyMMdd')
          let prefix = 'lottery'
          let suffix = file.name
          this.uploadForm.key = encodeURI(`${curr}/${prefix}_${suffix}`)
          console.log(this.uploadForm)
        }
        return true
      },
      confirmHandle () {
        this.$refs.curObjForm.validate(valid => {
          if (!valid) return
          if (this.curObj.id) return this.editHandle()
          this.newHandle()
        })
      },
      newHandle () {
        LotteryModel.create({
          name: this.curObj.name,
          startTime: this.curObj.startTime + ' 00:00:00',
          endTime: this.curObj.endTime + ' 23:59:59',
          image: this.curObj.image,
          lotteryDescription: this.curObj.lotteryDescription,
          prizeDescription: this.curObj.prizeDescription,
          advertising: this.curObj.advertising
        }).then(() => {
          // this.$router.push({ name: 'redenvelope.list', query: {id: this.curPid, pid: 0, sid: this.subjectId} })
          this.$router.push({ name: 'lottery.list' })
          this.$message({ message: '添加成功', type: 'success' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      editHandle () {
        LotteryModel.update({
          id: this.curObj.id,
          name: this.curObj.name,
          startTime: this.curObj.startTime + ' 00:00:00',
          endTime: this.curObj.endTime + ' 23:59:59',
          image: this.curObj.image,
          lotteryDescription: this.curObj.lotteryDescription,
          prizeDescription: this.curObj.prizeDescription,
          advertising: this.curObj.advertising
        }).then(() => {
          this.$message({ message: '更新成功', type: 'success' })
          this.$router.push({ name: 'lottery.list' })
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    padding: 20px
    font-size: 14px
    .el-input
      width: 50%
    .textarea
      width: 80%
    .avatar-uploader
        border: 1px dashed #d9d9d9
        border-radius: 6px
        cursor: pointer
        position: relative
        overflow: hidden
        width: 180px
        &:hover
          border-color: #409EFF
        .avatar-uploader-icon
          font-size: 28px
          color: #8c939d
          width: 178px
          height: 178px
          line-height: 178px
          text-align: center
        .avatar
          width: 178px
          height: 178px
          display: block
</style>



// WEBPACK FOOTER //
// src/views/LotteryNew.vue